import type { Group } from "../../types/group";
import { buildSeoPageGraph } from "./pageGraph";
import { PATH_GROUP_THERAPY } from "../../utils/constants";

export function buildGroupTherapyPageGraph(groups: Group[]) {
  return buildSeoPageGraph(PATH_GROUP_THERAPY, "gruppentherapie", {
    includeFounder: true,
    extra: {
      hasOfferCatalog: {
        "@type": "OfferCatalog",
        name: "Gruppentherapien",
        itemListElement: groups.map((group) => ({
          "@type": "Offer",
          itemOffered: {
            "@type": "MedicalTherapy",
            name: group.title,
            description: group.description || `Therapeutisches Gruppenangebot: ${group.title}`,
          },
        })),
      },
    },
  });
}
